import React, { useEffect, useMemo, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import './ecourt.css';
import { useAuth } from '../AuthContext';
import { ecourtApi, setEcourtUser } from './ecourtApi';
import EcourtHome from './EcourtHome';
import CaseSearch from './CaseSearch';
import CaseDetail from './CaseDetail';
import OrderViewer from './OrderViewer';
import CauseList from './CauseList';
import BulkRefresh from './BulkRefresh';
import LegalCheck from './LegalCheck';
import MyCases from './MyCases';
// import ActsSections from './Actssections';
import { BalanceContext, Empty } from './EcourtUi';

export default function EcourtApp() {
  const { user } = useAuth();
  const uid = user?.id;
  setEcourtUser(uid); // before children render, so their first call carries user_id
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    if (!uid) return;
    ecourtApi.usage().then(setBalance).catch(() => {});
  }, [uid]);

  const ctx = useMemo(() => ({ balance, setBalance }), [balance]);

  if (!uid) {
    return <div className="ecourt-app"><div className="ec-page"><Empty>Please sign in to use eCourts.</Empty></div></div>;
  }

  return (
    <BalanceContext.Provider value={ctx}>
      <div className="ecourt-app">
        <div className="ec-page">
          <Routes>
            <Route index element={<EcourtHome />} />
            <Route path="my-cases" element={<MyCases />} />
            <Route path="search" element={<CaseSearch />} />
            <Route path="case/:cnr" element={<CaseDetail />} />
            <Route path="case/:cnr/order/:file" element={<OrderViewer />} />
            <Route path="causelist" element={<CauseList />} />
            <Route path="refresh" element={<BulkRefresh />} />
            <Route path="legal-check" element={<LegalCheck />} />
            {/* <Route path="acts" element={<ActsSections />} /> */}
            <Route path="*" element={<Empty>This eCourts page does not exist.</Empty>} />
          </Routes>
        </div>
      </div>
    </BalanceContext.Provider>
  );
}